import React from 'react'
import { Card, Tag, Breadcrumb, Icon, Empty } from 'antd'
import * as _ from 'lodash'
import { RouteComponentProps } from 'react-router'
import { ComponentExt } from 'util/reactExt'

import Bread from './components/breadCrumb'

interface IProps extends RouteComponentProps<any> {}
interface IState {}
import styles from './index.scss'
// 征文 落地页
export default class ActivityIntro extends ComponentExt<IProps, IState> {
  state = {
    activityList: [],
    recommendList: [],
    tags: [],
    selectedTags: '',
    banner: '',
    bannerUrl: '',
  }

  async componentDidMount() {
    const bannerUrl = this.handleGetSearchParams('actBanner')
    this.setState({ bannerUrl })
    this.handleFetchActivityList()
    this.handleFetchLabelList({ label_type: 2 })
    this.handleFetchActivityBanner()
    this.handleFetchHotArticleList({ label_type: 2 })
  }

  async handleFetchActivityBanner() {
    try {
      const banner = await this.api.family.getFamilyActivityBanner()
      // console.log('banner', banner)
      this.setState({
        banner: banner[0],
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags }, () => this.forceUpdate())
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityList() {
    try {
      const {
        data: activityList,
      } = await this.api.family.getFamilyActivityList({})
      this.setState({ activityList })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleClickList = (e, data, type) => {
    const { bannerUrl } = this.state
    // 阻止冒泡
    e.stopPropagation()
    // console.log('data', data)
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'act') {
      WINOPEN(`#/team/actdetail/act?activityId=${data}`)
    } else if (type === 'actBanner') {
      WINOPEN(`#/team/actintro/act?actBanner=${bannerUrl}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/team/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  handleGetSearchParams = type => {
    return new URLSearchParams(this.props.location.search).get(type)
  }

  handleSliceString = (str, limit = 30) => {
    let res = str
    if (str && str.length > limit) {
      res = `${str.slice(0, limit)}···`
      return res
    }
    return res
  }

  handleRenderTag = () => {
    const { tags, selectedTags } = this.state
    if (_.isEmpty(tags)) {
      return
    }
    return _.map(tags, itm => (
      <Tag key={itm.id} onClick={e => this.handleClickList(e, itm, 'tag')}>
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderActivity = () => {
    const {
      activityList,
      banner,
    }: { activityList: any; banner: any } = this.state
    if (_.isEmpty(activityList)) {
      return
    }
    return (
      <ul>
        <div
          className={styles.banner}
          onClick={e => this.handleClickList(e, banner, 'actBanner')}
        >
          <img
            height="145"
            width="224"
            src={banner.img_url}
            alt={banner.remark}
          />
        </div>
        {_.map(activityList, (itm, idx) => (
          <li key={idx} onClick={e => this.handleClickList(e, itm.id, 'act')}>
            {this.handleSliceString(itm.title)}
          </li>
        ))}
      </ul>
    )
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <div
            className={styles.banner}
            key={itm.id}
            onClick={e => this.handleClickList(e, itm, 'li')}
          >
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </div>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  handleClickBreadCrumb = (link): any => {
    if (link) {
      const { history }: any = this.props
      history.push('/team')
    }
  }

  render() {
    const { bannerUrl } = this.state
    console.log('bannerUrl', bannerUrl)
    const breadCrumb: any = [
      { linkTo: '/team', text: '经传人' },
      { linkTo: '', text: '专题详情' },
    ]
    const mapProps: any = {
      breadCrumb: breadCrumb,
      handleClickBreadCrumb: this.handleClickBreadCrumb,
    }
    return (
      <div className={styles.detail}>
        <Bread {...mapProps} />
        <div className={styles.container}>
          <Card>{<img width="845" src={bannerUrl} alt="" />}</Card>
        </div>
        <div className={styles.others}>
          <div className={styles.contentRtBox}>
            <Card className={styles.activity} title="征文活动">
              {this.handleRenderActivity()}
            </Card>
            <Card title="全部标签">{this.handleRenderTag()}</Card>
            <Card className={styles.recommend} title="推荐">
              <ul>{this.handleRenderRecommend()}</ul>
            </Card>
          </div>
        </div>
      </div>
    )
  }
}
